<template>
  <div>
    <Loading v-if="isLoading"></Loading>
    <div v-else>
      <GlobalTable
        :enableAddButton="false"
        :title="title+' List'"
        :fields="fields"
        :items="items"
        :editButton="false"
        :redirectDetail="true"
        :isLoading="isLoading"
        :withCard="false"
      ></GlobalTable>
    </div>
  </div>
</template>

<script>
import GlobalTable from "@/templates/Table";
import Loading from "@/templates/Loading";

export default {
  name: "FreezerInformation",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "Freezer Information",
      fields: [
        { key: "freezer_information", label: "Freezer", sorter: true },
        { key: "serial_number", label: "Serial Number", sorter: true },
        { key: "date_accepted_time", label: "Date Accepted", sorter: true },
      ],
      showImages: "",
      preview: false
    };
  },
  props: {
    items: {
      type: [Array, Object],
      default: () => [],
    },
    isLoading: {
        type: Boolean,
        default: false
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function (id) {
    },
    back: function () {
      this.$router.go(-1);
    },
    
    previewImages: function (img) {
        this.showImages = "";
        this.preview = true;
        this.showImages = img;
    },
  
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
